import * as v from "valibot";

const contactSchema = v.object({
  phoneNumber: v.pipe(v.string(), v.minLength(1, "Validation.PhoneNumber.NotEmpty")),
  emailAddress: v.pipe(
    v.string(),
    v.minLength(1, "Validation.EmailAddress.NotEmpty"),
    v.email("Validation.EmailAddress.InvalidFormat"),
  ),
  billingStreet: v.pipe(v.string(), v.minLength(1, "Validation.Street.NotEmpty")),
  billingTown: v.pipe(v.string(), v.minLength(1, "Validation.Town.NotEmpty")),
  billingPostCode: v.pipe(v.string(), v.minLength(1, "Validation.PostCode.NotEmpty")),
  billingCountryCode: v.pipe(v.string(), v.minLength(1, "Validation.CountryCode.NotEmpty")),
});

const personSchema = v.object({
  titlePrefix: v.optional(v.string()),
  firstName: v.pipe(v.string(), v.minLength(1, "Validation.FirstName.NotEmpty")),
  lastName: v.pipe(v.string(), v.minLength(1, "Validation.FirstName.NotEmpty")),
  titleSuffix: v.optional(v.string()),
});

const companySchema = v.object({
  ...v.object({
    isCompany: v.literal(true),
    customerName: v.pipe(v.string(), v.minLength(1, "Validation.CustomerName.NotEmpty")),
    registrationNumber: v.pipe(
      v.string(),
      v.minLength(1, "Validation.RegistrationNumber.NotEmpty"),
      v.maxLength(18, "IČO je príliš dlhé"),
    ),
    vatNumber: v.string(),
    taxNumber: v.optional(v.string()),
    notVatRegistered: v.optional(
      v.pipe(
        v.union([v.string(), v.boolean(), v.number()]),
        v.transform((v) => Boolean(v)),
      ),
      false,
    ),
  }).entries,
  ...personSchema.entries,
});

const citizenSchema = v.object({
  ...v.object({
    isCompany: v.literal(false),
  }).entries,
  ...personSchema.entries,
});

const companyOrPersonSchema = v.variant("isCompany", [citizenSchema, companySchema]);

const shippingAddressSchema = v.variant("differentShipping", [
  v.object({
    differentShipping: v.literal(false),
    shippingAddress: v.optional(
      v.object({
        addressId: v.optional(v.string()),
        street: v.optional(v.string()),
        town: v.optional(v.string()),
        postCode: v.optional(v.string()),
        countryCode: v.optional(v.string()),
      }),
    ),
  }),
  v.object({
    differentShipping: v.literal(true),
    shippingAddress: v.object({
      addressId: v.optional(v.string()),
      street: v.pipe(v.string(), v.minLength(1, "Validation.Street.NotEmpty")),
      town: v.pipe(v.string(), v.minLength(1, "Validation.Town.NotEmpty")),
      postCode: v.pipe(v.string(), v.minLength(1, "Validation.PostCode.NotEmpty")),
      countryCode: v.pipe(v.string(), v.minLength(1, "Validation.CountryCode.NotEmpty")),
    }),
  }),
]);

export const customerSchema = v.intersect([
  companyOrPersonSchema,
  contactSchema,
  shippingAddressSchema,
]);

export const CheckoutFormSchema = v.object({
  note: v.optional(v.string()),
  shippingMethodId: v.string(),
  paymentMethodId: v.string(),
  customer: customerSchema,
  dpdPickupPoint: v.nullish(
    v.object({
      // id: coerce(number(), Number),
      pusId: v.string(),
      name: v.string(),
      street: v.string(),
      town: v.string(),
      postCode: v.string(),
      countryCode: v.string(),
    }),
  ),
});

export type CheckoutFormSchema = v.InferOutput<typeof CheckoutFormSchema>;
// import * as z from 'zod';
//
// const CustomerSchema = z
//   .strictObject({
//     isCompany: z.boolean(),
//     customerName: z.string().optional(),
//     titlePrefix: z.string().optional(),
//     firstName: z.string().nonempty({ message: 'Validation.FirstName.NotEmpty' }),
//     lastName: z.string().nonempty({ message: 'Validation.LastName.NotEmpty' }),
//     titleSuffix: z.string().optional(),
//     registrationNumber: z.string().optional(),
//     vatNumber: z.string().optional(),
//     taxNumber: z.string().optional(),
//     notVatRegistered: z.coerce.boolean().default(false),
//     phoneNumber: z.string().nonempty({ message: 'Validation.PhoneNumber.NotEmpty' }),
//     emailAddress: z
//       .string()
//       .nonempty({ message: 'Validation.EmailAddress.NotEmpty' })
//       .email({ message: 'Validation.EmailAddress.InvalidFormat' }),
//     billingStreet: z.string().nonempty({ message: 'Validation.Street.NotEmpty' }),
//     billingTown: z.string().nonempty({ message: 'Validation.Town.NotEmpty' }),
//     billingPostCode: z.string().nonempty({ message: 'Validation.PostCode.NotEmpty' }),
//     billingCountryCode: z.string().nonempty({ message: 'Validation.CountryCode.NotEmpty' }),
//     differentShipping: z.boolean(),
//     shippingAddress: z
//       .strictObject({
//         addressId: z.string().optional(),
//         street: z.string().optional(),
//         town: z.string().optional(),
//         postCode: z.string().optional(),
//         countryCode: z.string().optional(),
//       })
//       .optional(),
//   })
//   .superRefine((data, ctx) => {
//     // nazov firmy
//     if (data.isCompany && !data.customerName) {
//       ctx.addIssue({
//         code: 'custom',
//         path: ['customerName'],
//         message: 'Validation.CustomerName.NotEmpty',
//       });
//     }
//
//     // ico
//     if (data.isCompany && !data.registrationNumber) {
//       ctx.addIssue({
//         code: 'custom',
//         path: ['registrationNumber'],
//         message: 'Validation.RegistrationNumber.NotEmpty',
//       });
//     } else if (data.isCompany && data.registrationNumber) {
//       if (data.registrationNumber.length > 18) {
//         ctx.addIssue({
//           code: 'custom',
//           path: ['registrationNumber'],
//           message: 'IČO je príliš dlhé',
//         });
//       }
//       if (data.registrationNumber.length < 1) {
//         ctx.addIssue({
//           code: 'custom',
//           path: ['registrationNumber'],
//           message: 'IČO je povinný údaj',
//         });
//       }
//     }
//
//     // dodacia adresa
//     if (data.differentShipping) {
//       if (!data.shippingAddress?.street) {
//         ctx.addIssue({
//           code: 'custom',
//           path: ['shippingAddress.street'],
//           message: 'Validation.Street.NotEmpty',
//         });
//       }
//
//       if (!data.shippingAddress?.town) {
//         ctx.addIssue({
//           code: 'custom',
//           path: ['shippingAddress.town'],
//           message: 'Validation.Town.NotEmpty',
//         });
//       }
//
//       if (!data.shippingAddress?.postCode) {
//         ctx.addIssue({
//           code: 'custom',
//           path: ['shippingAddress.postCode'],
//           message: 'Validation.PostCode.NotEmpty',
//         });
//       }
//
//       if (!data.shippingAddress?.countryCode) {
//         ctx.addIssue({
//           code: 'custom',
//           path: ['shippingAddress.countryCode'],
//           message: 'Validation.CountryCode.NotEmpty',
//         });
//       }
//     }
//   });
//
// export const CheckoutFormSchema = z.object({
//   // Basket
//   note: z.string().optional(),
//   // Methods
//   shippingMethodId: z.string(),
//   paymentMethodId: z.string(),
//   // Customer
//   customer: CustomerSchema,
//   dpdPickupPoint: z
//     .strictObject({
//       id: z.coerce.number(),
//       pusId: z.string(),
//       name: z.string(),
//       street: z.string(),
//       town: z.string(),
//       postCode: z.string(),
//       countryCode: z.string(),
//     })
//     .nullish(),
// });
//
// export type CheckoutFormModel = z.infer<typeof CheckoutFormSchema>;

